var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingExpensesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 32 32.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bullhorn-solid",
    d: "M30,1.948A2,2,0,0,0,26.581.529L23.856,3.26A16,16,0,0,1,12.544,7.948H4a4,4,0,0,0-4,4v6a4,4,0,0,0,4,4v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2v-8h.544a16,16,0,0,1,11.313,4.687l2.725,2.725A2,2,0,0,0,30,27.942V18.723a4.107,4.107,0,0,0,2-3.775,4.107,4.107,0,0,0-2-3.775ZM26,6.742V23.154a19.992,19.992,0,0,0-13.456-5.206H12v-6h.544A19.992,19.992,0,0,0,26,6.742Z",
    transform: "translate(0 0.056)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingExpensesIcon);
export default __webpack_public_path__ + "static/media/marketing-expenses-icon.cbdf08f319001a7edf00ac2c631f3b1f.svg";
export { ForwardRef as ReactComponent };